"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WatchJS = require("melanke-watchjs");
var watch = WatchJS.watch;

var Billing_Form = void 0;

var Metrics = void 0;
var Noun_Stripe = void 0;
var Payment = void 0;
var StripeStore = void 0;
var number_with_commas = void 0;
var url_to_array = void 0;
var indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) return i;
    }
    return -1;
};

Metrics = require("../helpers/metrics").default;

Noun_Stripe = require("../legacy-store/noun_stripe").default;

Payment = require("payment");

url_to_array = require("../helpers/url_to_array").default;

number_with_commas = require("../helpers/number_with_commas").default;

StripeStore = require("../stores/stripestore").default;

Billing_Form = function () {
    var Billing_Form = function () {
        function Billing_Form(form, action) {
            _classCallCheck(this, Billing_Form);

            var couponValue = void 0;
            var me = void 0;
            me = this;
            me.form = form;
            me.action = action;
            if ((0, _jquery2.default)(".new-form").attr("data-plan-type") == "team") {
                this.form_type = "team";
                this.show_coupon = false;
                this.base_price = {
                    monthly: StripeStore.plans.team.monthly.price,
                    yearly: StripeStore.plans.team.yearly.price
                };
            } else if ((0, _jquery2.default)(".new-form").attr("data-plan-type") == "pro") {
                this.form_type = "pro";
                this.base_price = {
                    monthly: StripeStore.plans.pro.monthly.price,
                    yearly: StripeStore.plans.pro.yearly.price
                };
            }
            this.user_price = JSON.parse(JSON.stringify(this.base_price));
            this.full_price = JSON.parse(JSON.stringify(this.base_price));
            this.min_seats = this.form.data("min-seats");
            this.process_seats();
            this.render_prices();
            Payment.formatCardNumber((0, _jquery2.default)("#card-number"));
            (0, _jquery2.default)("#" + form.prop("id") + " :input").on("focus", function (e) {
                var $this = void 0;
                var label = void 0;
                $this = (0, _jquery2.default)(this);
                $this.removeClass("error");
                label = $this.nextAll("label");
                label.removeClass("error");
                return label.text(label.data("label-text"));
            });
            (0, _jquery2.default)("#card-number").on("keyup", function (e) {
                return me.update_card_type();
            });
            (0, _jquery2.default)("#card-number").on("keydown", function (e) {
                return me.update_card_type();
            });
            (0, _jquery2.default)(".seats").on("blur", function () {
                return me.process_seats();
            });
            me.plan_type_selection();
            watch(this, "user_price", function () {
                return me.render_prices();
            });
            if ((0, _jquery2.default)(".apply-coupon").length > 0) {
                (0, _jquery2.default)(".apply-coupon").on("click", function (e) {
                    e.preventDefault();
                    return me.apply_coupon((0, _jquery2.default)(this).parent().find("input"));
                });
                (0, _jquery2.default)(".coupon-value .icon-link").on("click", function (e) {
                    e.preventDefault();
                    me.coupon = null;
                    return me.render_coupon();
                });
            }
            watch(this, "coupon", function () {
                me.render_coupon();
                return me.process_coupon();
            });
            couponValue = (0, _jquery2.default)("#coupon").val();
            if (couponValue !== "") {
                me.apply_coupon((0, _jquery2.default)("#coupon"));
            }
            me.date_selection();
            form.submit(function (e) {
                (0, _jquery2.default)("#" + this.id + " ul li").children().removeClass("error");
                e.preventDefault();
                me.submit_btn.prop("disabled", "true");
                return me.create_token();
            });
        }

        _createClass(Billing_Form, [{
            key: "parse_errors",
            value: function parse_errors(owner, _ref) {
                var errors = _ref.errors;

                if (errors.processing_error) {
                    owner.render_error((0, _jquery2.default)("#card-number"), errors.processing_error);
                    delete errors.processing_error;
                }
                if (errors.incorrect_cvc) {
                    owner.render_error((0, _jquery2.default)("#card-cvc"), errors.incorrect_cvc);
                    delete errors.incorrect_cvc;
                }
                if (errors.card_expiry) {
                    owner.render_error((0, _jquery2.default)("#card-expiration"), errors.card_expiry);
                    delete errors.card_expiry;
                }
                if (errors.card_declined) {
                    owner.render_error((0, _jquery2.default)("#card-number"), errors.card_declined);
                    return delete errors.card_declined;
                }
            }
        }, {
            key: "render_error",
            value: function render_error($input, message) {
                var $label = void 0;
                $label = $input.nextAll("label");
                $input.addClass("error");
                $label.addClass("error show");
                $label.html(message);
                this.submit_btn.removeAttr("disabled");
                return this.submit_btn.removeClass("processing");
            }
        }, {
            key: "create_token",
            value: function create_token() {
                var $input = void 0;
                var data = void 0;
                var form = void 0;
                var i = void 0;
                var input = void 0;
                var len = void 0;
                var me = void 0;
                var ref = void 0;
                var stripe = void 0;
                me = this;
                form = me.form;
                data = {};
                ref = form.find("input");
                for (i = 0, len = ref.length; i < len; i++) {
                    input = ref[i];
                    $input = (0, _jquery2.default)(input);
                    if ($input.prop("name").length > 0) {
                        if ($input.prop("name") === "plan") {
                            if ($input.prop("checked") === true) {
                                data.plan = $input.val();
                            }
                        } else {
                            if ($input.prop("type") === "checkbox") {
                                data[$input.prop("name")] = $input.prop("checked");
                            } else {
                                data[$input.prop("name")] = $input.val();
                            }
                        }
                    } else {
                        if ($input.prop("id") === "card-expiration") {
                            data["card-exp-month"] = $input.val().split("/")[0];
                            data["card-exp-year"] = $input.val().split("/")[1];
                        } else {
                            data[$input.prop("id").split(" ")[0]] = $input.val();
                        }
                    }
                }
                if ((0, _jquery2.default)("#receipt-info").val() !== "") {
                    data["receipt-info"] = (0, _jquery2.default)("#receipt-info").val();
                }
                this.submit_btn.addClass("processing");

                stripe = new Noun_Stripe(form.attr("data-stripe-key"), data, (0, _jquery2.default)('div[data-component-name="billing"]').data("account-type"), me.action, form.data("username"));
                if (stripe.errors !== void 0) {
                    this.parse_errors(this, stripe);
                }
                watch(stripe, "errored", function () {
                    me.parse_errors(me, this);
                });
                if (this.action === "a-la-carte") {
                    return stripe.a_la_carte(form.data("term-slug"), form.data("icon-id"));
                }
            }
        }, {
            key: "plan_type_selection",
            value: function plan_type_selection() {
                var $cost_total = void 0;
                var me = void 0;
                me = this;
                $cost_total = (0, _jquery2.default)(".cost-total").text("$" + me.full_price[me.plan_selected]);
                return (0, _jquery2.default)("#plan-selection").on("click", "input", function (e) {
                    if ((0, _jquery2.default)(".plan-monthly").prop("checked")) {
                        me.plan_selected = "monthly";
                    } else if ((0, _jquery2.default)(".plan-yearly").prop("checked")) {
                        me.plan_selected = "yearly";
                    }
                    return me.render_prices();
                });
            }
        }, {
            key: "date_selection",
            value: function date_selection() {
                var $card_expiry = void 0;
                $card_expiry = (0, _jquery2.default)("#card-expiration");
                return $card_expiry.on("keyup", function (_ref2) {
                    var keyCode = _ref2.keyCode;

                    var value = void 0;
                    value = $card_expiry.val();
                    if (value.length === 2 && keyCode !== 8) {
                        return $card_expiry.val(value + "/");
                    }
                });
            }
        }, {
            key: "update_card_type",
            value: function update_card_type() {
                var $card_number = void 0;
                var $card_type = void 0;
                var card = void 0;
                $card_number = (0, _jquery2.default)("#card-number");
                $card_type = (0, _jquery2.default)("#card-type");
                card = (0, _jquery2.default)("#card-number").prop("class").split(" ")[0];
                if (card !== "unknown") {
                    $card_type.text(card);
                }
                if (!$card_number.val()) {
                    return $card_type.text("");
                }
            }
        }, {
            key: "check_referral",
            value: function check_referral(couponField) {
                var codeVals = void 0;
                var couponCode = void 0;
                var ref = void 0;
                var referralCodes = void 0;
                referralCodes = ["pros-b4-bros", "U9cYj4F1"];
                couponCode = couponField.val();
                codeVals = couponCode.split(":");
                if (codeVals.length === 2 && (ref = codeVals[0], indexOf.call(referralCodes, ref) >= 0)) {
                    this.referring_user = codeVals[1];
                    couponField.val(codeVals[0]);
                    return codeVals[0];
                }
                return couponCode;
            }
        }, {
            key: "apply_coupon",
            value: function apply_coupon($el) {
                var couponCode = void 0;
                var form = void 0;
                var me = void 0;
                me = this;
                form = me.form;
                couponCode = "";
                if ($el.length > 0) {
                    couponCode = me.check_referral($el);
                }
                if (couponCode !== "") {
                    return _jquery2.default.ajax({
                        url: "//" + url_to_array[2] + "/coupon/" + couponCode + "/",
                        type: "GET",
                        success: function success(_ref3, status, xhr) {
                            var coupon = _ref3.coupon;

                            return me.coupon = coupon;
                        },
                        error: function error(xhr, status, _error) {
                            me.coupon = null;
                            return me.render_error((0, _jquery2.default)("#coupon"), gettext("This is not a valid promotional code"));
                        }
                    });
                }
            }
        }, {
            key: "process_seats",
            value: function process_seats() {
                var $seats = void 0;
                var full_price = void 0;
                var plan = void 0;
                var price = void 0;
                var ref = void 0;
                var seatsVal = void 0;
                $seats = (0, _jquery2.default)(".seats");
                seatsVal = parseInt($seats.val());
                if (seatsVal < this.min_seats) {
                    this.render_error((0, _jquery2.default)("#seats"), "Too few seats");
                    seatsVal = this.min_seats;
                }
                this.seat_number = seatsVal;
                $seats.val(seatsVal);
                if (seatsVal > 0) {
                    ref = this.base_price;
                    for (plan in ref) {
                        price = ref[plan];
                        full_price = parseFloat(price) * seatsVal;
                        this.full_price[plan] = String(full_price.toFixed(2));
                    }
                }
                return this.process_coupon();
            }
        }, {
            key: "process_coupon",
            value: function process_coupon() {
                var coupon = void 0;
                var plan = void 0;
                var price = void 0;
                var ref = void 0;
                var results = void 0;
                var user_price = void 0;
                coupon = this.coupon;
                if (coupon !== null) {
                    ref = this.full_price;
                    results = [];
                    for (plan in ref) {
                        price = ref[plan];
                        price = parseFloat(price);
                        if (coupon.percent_off !== null) {
                            user_price = price - price / 100 * coupon.percent_off;
                        }
                        if (coupon.amount_off !== null) {
                            user_price = price - coupon.amount_off / 100;
                        }
                        if (user_price < 0) {
                            user_price = 0;
                        }
                        results.push(this.user_price[plan] = String(user_price.toFixed(2)));
                    }
                    return results;
                } else {
                    return this.user_price = JSON.parse(JSON.stringify(this.full_price));
                }
            }
        }, {
            key: "get_coupon_duration_copy",
            value: function get_coupon_duration_copy() {
                var coupon = void 0;
                var durationCopy = void 0;
                var fmts = void 0;
                coupon = this.coupon;
                durationCopy = null;
                if (coupon !== null) {
                    durationCopy = gettext("Your discount will expire ");
                    if (coupon.duration === "once") {
                        durationCopy += gettext("after your first payment");
                    }
                    if (coupon.duration === "repeating") {
                        fmts = gettext("in %s month", "in %s months", coupon.duration_in_months);
                        durationCopy += interpolate(fmts, [coupon.duration_in_months]);
                    }
                    if (coupon.duration === "forever") {
                        durationCopy = gettext("Your discount will last forever");
                    }
                    durationCopy = "<span class=\"coupon-duration\">" + durationCopy + "<span><br>";
                }
                return durationCopy;
            }
        }, {
            key: "render_coupon",
            value: function render_coupon() {
                var $referringFld = void 0;
                var coupon = void 0;
                var couponDetails = void 0;
                var me = void 0;
                var referringUser = void 0;
                me = this;
                coupon = this.coupon;
                referringUser = this.referring_user;
                couponDetails = "";
                if (coupon !== null && this.show_coupon === true) {
                    if (referringUser) {
                        $referringFld = (0, _jquery2.default)("#referring-user");
                        if ($referringFld.length > 0) {
                            $referringFld.val(referringUser);
                        } else {
                            this.form.append("<input type=\"hidden\" id=\"referring-user\" name=\"referring-user\" value=\"" + referringUser + "\">");
                        }
                    }
                    if (coupon.percent_off) {
                        couponDetails = coupon.percent_off + "%";
                    } else if (coupon.amount_off) {
                        couponDetails = "$" + coupon.amount_off / 100;
                    }
                    (0, _jquery2.default)(".coupon-field").addClass("hidden");
                    (0, _jquery2.default)(".coupon-name").text(coupon.code + ": " + couponDetails + " " + gettext("off your NounPro subscription"));
                    return (0, _jquery2.default)(".coupon-value").removeClass("hidden");
                } else {
                    (0, _jquery2.default)("#referring-user").remove();
                    (0, _jquery2.default)(".coupon-value").addClass("hidden");
                    return (0, _jquery2.default)(".coupon-field").removeClass("hidden");
                }
            }
        }, {
            key: "render_prices",
            value: function render_prices() {
                var $labelPrice = void 0;
                var costTotal = void 0;
                var coupon = void 0;
                var couponDetails = void 0;
                var durationCopy = void 0;
                var labelStr = void 0;
                var me = void 0;
                var plan = void 0;
                var price = void 0;
                var prices = void 0;
                var ref = void 0;
                me = this;
                coupon = this.coupon;
                prices = this.user_price;
                durationCopy = this.get_coupon_duration_copy();
                costTotal = "$" + number_with_commas(this.user_price[this.plan_selected]);
                if (this.user_price[this.plan_selected] < this.full_price[this.plan_selected]) {
                    costTotal = "<span class=\"cost-full\">$" + number_with_commas(this.full_price[this.plan_selected]) + "</span> " + costTotal;
                    (0, _jquery2.default)(".price-status").addClass("has-coupon");
                } else {
                    (0, _jquery2.default)(".price-status").removeClass("has-coupon");
                }
                if (coupon === null || coupon.percent_off !== null) {
                    ref = this.user_price;
                    for (plan in ref) {
                        price = ref[plan];
                        $labelPrice = (0, _jquery2.default)("label[for=" + me.form_type + "-" + plan + "] .dollar-value");
                        labelStr = "$" + number_with_commas(price);
                        $labelPrice.html(labelStr);
                        (0, _jquery2.default)(".pro-" + plan + "-cost").text(labelStr);
                    }
                }
                if (coupon !== null && this.form_type === "team") {
                    if (coupon.percent_off) {
                        couponDetails = coupon.percent_off + "%";
                    } else if (coupon.amount_off) {
                        couponDetails = "$" + coupon.amount_off / 100;
                    }
                    (0, _jquery2.default)(".team-discount span").text(couponDetails);
                }
                (0, _jquery2.default)(".month-year-interval").text(this.plan_selected);
                (0, _jquery2.default)(".pro-full-cost").text("$" + this.full_price[this.plan_selected]);
                (0, _jquery2.default)(".cost-total").html(costTotal);
                if (durationCopy !== null) {
                    (0, _jquery2.default)(".discount-duration").html(durationCopy);
                    (0, _jquery2.default)(".when-you-are-billed").addClass("hidden");
                    if (coupon.duration === "forever") {
                        (0, _jquery2.default)(".after-discount-ends").addClass("hidden");
                    } else {
                        (0, _jquery2.default)(".after-discount-ends").removeClass("hidden");
                    }
                    return (0, _jquery2.default)(".when-you-are-billed-discount").removeClass("hidden");
                } else {
                    (0, _jquery2.default)(".discount-duration").text("");
                    (0, _jquery2.default)(".when-you-are-billed-discount").addClass("hidden");
                    return (0, _jquery2.default)(".when-you-are-billed").removeClass("hidden");
                }
            }
        }, {
            key: "reset_form",
            value: function reset_form() {
                return (0, _jquery2.default)("#plans-form input[type=text]").val("");
            }
        }]);

        return Billing_Form;
    }();

    Billing_Form.prototype.form = void 0;

    Billing_Form.prototype.is_valid = true;

    Billing_Form.prototype.coupon = null;

    Billing_Form.prototype.show_coupon = true;

    Billing_Form.prototype.referring_user = void 0;

    Billing_Form.prototype.form_type = null;

    Billing_Form.prototype.base_price = {
        monthly: "9.99",
        yearly: "39.99"
    };

    Billing_Form.prototype.full_price = {};

    Billing_Form.prototype.user_price = {};

    Billing_Form.prototype.plan_selected = "yearly";

    Billing_Form.prototype.seat_number = 1;

    Billing_Form.prototype.errors = {};

    Billing_Form.prototype.submit_btn = (0, _jquery2.default)("button[type='submit']");

    return Billing_Form;
}();

exports.default = Billing_Form;